let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jlJ8d")).then(() => parcelRequire('6keru'));